import React from "react";

export default function SmartInput({ child, value, onChange }) {
  const valueType = child.Flex2?.toLowerCase();

  if (valueType === "boolean" || valueType === "switch") {
    return (
      <label className="inline-flex items-center space-x-2">
        <input
          type="checkbox"
          className="form-checkbox h-5 w-5 text-green-600"
          checked={value === true || value === "true"}
          onChange={(e) => onChange?.(e.target.checked)}
        />
        <span className="text-sm text-gray-700">{child.SetupDetailName}</span>
      </label>
    );
  }

  const commonProps = {
    className: "w-full px-3 py-2 border border-gray-300 rounded-md",
    placeholder: child.SetupDetailName,
    value: value ?? "", // important: controlled input
    onChange: (e) => onChange?.(e.target.value),
  };

  return (
    <div className="space-y-1">
      <label className="block font-medium text-gray-800">
        {child.SetupDetailName}
      </label>
      {(() => {
        switch (valueType) {
          case "number":
            return <input type="number" {...commonProps} />;
          case "textarea":
            return <textarea rows="3" {...commonProps} />;
          case "date":
            return <input type="date" {...commonProps} />;
          case "text":
          default:
            return <input type="text" {...commonProps} />;
        }
      })()}
    </div>
  );
}
